import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  AMOUNTPOINTLEFT = 7;
  AMOUNTPOINTLEFTFORADHHARNUMBER = 12;

  AMOUNTPOINTRIGHT = 0;
  /* MAX length Varibles*/
  MAX_30 = 30;
  MAX_2000 = 2000;
  MAX_200 = 200;
  MAX_100 = 100;
  MAX_60 = 60;
  MAX_20 = 20;
  MAX_10 = 10;
  MAX_15 = 15;
  MAX_4 = 4;
  MAX_5 = 5;
  MAX_3 = 3;
  MAX_32 = 32;
  MAX_50 = 50;
  MAX_300 = 300;
  MAX_13 = 13;
  MAX_6 = 6;
  MAX_7 = 7;
  MAX_8 = 8;
  MAX_11 = 11;
  MAX_12 = 12;
  MAX_25 = 25;
  PASSWORD = 32;

  /* End MAX length Varibles*/

  /* pattern use for validation */
  NAME = /^([a-zA-Z][a-zA-Z\s]*)$/; // use in specilstMaster and CategoryMaster
  STATE_NAME = /^([a-zA-Z][a-zA-Z\s]*)$/;
  CITY_NAME = /^([a-zA-Z][a-zA-Z\s]*)$/;
  LANGUAGE_NAME = /^([a-zA-Z][a-zA-Z\s]*)$/;
  ONLY_NUMBERS = '^[0-9]*$';
  // ONLY_NUMBERS_AND_DOT = /^[0-9.]{1,15}$/;
  ONLY_NUMBERS_AND_DOT = /^[0-9]+(?:\.[0-9]+)?$/;
  PATTERN_FOR_ALPHABATES_AND_SPACE_AND_DASH_DIGIT = '^[a-zA-Z0-9- ]*$';
  PATTERN_FOR_ALPHABATES_AND_SPACE_AND_DASH = '^[a-zA-Z- ]*$';
  // PATTERN_FOR_ALPHABATES_AND_SPACE_AND_ROUND_BRACKETS = '^[a-zA-Z() ]*$';
  PATTERN_FOR_ALPHABATES_AND_SPACE_AND_ROUND_BRACKETS =
    '^([a-zA-Z()][a-zA-Z() ]*)';
  LAB_MASTER_NAME = /.*\S.*/;
  // ONLY_SPACE_NOT_ALLOW = /^\S*$/;
  ONLY_SPACE_NOT_ALLOW = /.*\S.*/;

  LEADING_SPACE_NOT_ALLOW = /^([a-zA-Z0-9][a-zA-Z0-9\s]*)/;
  PATTERN_FOR_USER_ROLE_NAME = /^([a-zA-Z][a-zA-Z[\_\]\s]*)$/; // added by Dhrumin
  PATTERN_FOR_PREFIX = '^([a-zA-Z0-9][a-zA-Z0-9s!@#$%^&*()-_]*)';
  STARTING_WITH_ALPHABATES_AND_DIGIT =
    /^(\w|\d)([A-z\d_@.#$=!%^)(\]:\*;\?\/\,}{ '\|<>\[&\+-]*)$/; // added by ashish
  PATTERN_FOR_ALPHANUMERIC_DIGIT_SPECIAL_ESCAPE_CHARS = /.*\S.*/;
  PATTERN_FOR_ONLY_ALPHABATES = '^[a-zA-Z]*$';
  PATTERN_FOR_ALPHABATES_AND_SPACE_AND_DIGIT = '^[a-zA-Z0-9 ]*$';
  PATTERN_FOR_ALPHABATES_AND_DIGIT = '^[a-zA-Z0-9]*$';
  PATTERN_FOR_ALPHABATES_AND_SPACE = '^([a-zA-Z][a-zA-Z ]*)$';
  PATTERN_FOR_ALPHABATES_AND_ORG_NAME = '^([a-zA-Z][a-zA-Z .&$@]*)$';
  PATTERN_FOR_ALPHABATES_NUMBER_AND_SPACE = '^([a-zA-Z0-9][a-zA-Z0-9 ]*)';
  // PATTERN_FOR_EMAIL = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  PATTERN_FOR_EMAIL = '[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,50}'; // change by ashish
  // PATTERN_FOR_EMAIL = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  // PATTERN_FOR_EMAIL = '/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.' +
  //   '[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/';
  // PATTERN_FOR_EMAIL = '[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}';
  PATTERN_FOR_EMAIL_OR_PHONE_NO =
    '^(?:([a-zA-Z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3})|([0-9]{10,13}))$';
  PATTERN_FOR_EMAIL_OR_USERNAME =
    '^(?:([a-zA-Z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3})|([a-zA-Z0-9]*))$';
  PATTERN_FOR_PHONE_NO = '^[0-9]{10}$';
  PATTERN_FOR_NUMBER = '^[0-9]*$';
  PATTERN_FOR_DECIMAL_NUMBER = '^[0-9.]*$';
  PATTERN_FOR_PINCODE = '^[0-9]{6}$';
  PATTERN_FOR_LANDLINE_NO = '^[0-9]{11}$';
  PATTERN_FOR_ADHARCARD_NO = '^[0-9]{12}$';
  PATTERN_FOR_HSN_CODE = '^[0-9]{8}$';
  PATTERN_FOR_SAC_CODE = '^[0-9]{6}$';
  PATTERN_FOR_PANCARD_NO = '^[A-Z]{5}[0-9]{4}[A-Z]{1}$';
  PATTERN_FOR_NOTARY_CERTIFICATE_NUMBER = /[A-Z]{2}\d{4}[\/]\d{4}/;
  PATTERN_FOR_DRIVING_LICENCE_NUMBER = /[A-Z]{2}\d{13}/;

  PATTERN_FOR_NAME_WITH_COMA_AND_SPACE = /^([a-zA-Z][a-zA-Z, ]*)$/;
  PATTERN_FOR_NAME_WITH_DASH_SLASH_AND_SPACE = /^([a-zA-Z][a-zA-Z-/ ]*)$/;
  PATTERN_FOR_NAME_WITH_COMA_CIRCLE_BRACKETS = /^([a-zA-Z][a-zA-Z,() ]*)$/;
  PATTERN_FOR_NAME_WITH_EMPERSON_AND_SPACE = /^([a-zA-Z][a-zA-Z& ]*)$/;

  // PATTERN_FOR_PASSWORD = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,32}$/;
  PATTERN_FOR_PASSWORD = /^[a-zA-Z0-9]{6,32}$/;
  // PATTERN_FOR_PASSWORD = /^(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{6,32}$/;
  PATTERN_FOR_BAR_COUNCIL_NO = /[a-zA-Z]{2}[\/]\d[0-9]{0,5}[\/][0-9]{4}/;
  PATTERN_FOR_GST_NO = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1}/;
  PATTERN_FOR_NUMBER_PLATE =
    '^[a-zA-Z]{2}[ -][0-9]{1,2}(?: [a-zA-Z])?(?: [a-zA-Z]*)? [0-9]{4}$';
  PATTERN_NOT_ALLOW_SPACE = /^\S*$/;
  PATTERN_FOR_DATE =
    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
  /* End pattern use for validation */

  EMAIL_REQUIRED = 'Email is required!';
  EMAIL_INVALID = 'Please enter valid Email.';
  PHONE_NUMBER_REQUIRED = 'Phone Number is required!';
  PHONE_NUMBER_INVALID = 'Please enter valid Phone Number.';
  PASSWORD_REQUIRED = 'Password is required!';
  CURRENT_PASSWORD_REQUIRED = 'Current Password is required!';
  NEW_PASSWORD_REQUIRED = 'New Password is required!';
  CONFIRM_PASSWORD_REQUIRED = 'Confirm Password is required!';
  CONFIRM_NEW_PASSWORD_REQUIRED = 'Confirm New Password is required!';
  PASSWORD_NOT_MATCHED = 'Password and Confirm new password not equal.';
  SINGLE_SPACE_PASSWORD = 'Only space is not allowed in the password.';
  CONFIRM_PASSWORD_NOT_MATCHED = 'Password and Confirm password not equal.';
  // PASSWORD_INVALID = 'Should contains atleast 6 characters,one upper case letter,lower case letter,digit and special character like *,@,$.'
  PASSWORD_INVALID = 'Should contains atleast 6 characters and digits.';
  NAME_INVALID = 'Please enter valid Name.';

  FIRST_NAME_REQUIRED = 'First Name is required!';
  FIRST_NAME_INVALID = 'Please enter valid First Name';

  MIDDLE_NAME_REQUIRED = 'Middle Name is required!';
  MIDDLE_NAME_INVALID = 'Please enter valid Middle Name';

  LAST_NAME_REQUIRED = 'Last Name is required!';
  LAST_NAME_INVALID = 'Please enter valid Last Name';

  DISPLAY_NAME_REQUIRED = 'Display Name is required!';
  DISPLAY_NAME_INVALID = 'Please enter valid Display Name';

  CUSTOMER_CODE_REQUIRED = 'Customer Code is required!';

  GST_INVALID = 'Please enter valid Gst No';
  PAN_INVALID = 'Please enter valid Pan No';

  MACHINE_TYPE_REQUIRED = 'Type is required!';
  CUSTOMER_REQUIRED = 'Customer is required!';
  MACHINE_REQUIRED = 'Machine is required!';
  SERVICE_REQUIRED = 'Service is required!';
  PROBLEM_REQUIRED = 'Problem is required!';
  TECHNICIAN_REQUIRED = 'Technician/Engineer is required!';
  ATTENDANT_REQUIRED = 'Attendent is required!';
  STAFF_REQUIRED = 'Staff is required!';
  ENGINEER_REQUIRED = 'Engineer is required!';
  PRIORITY_REQUIRED = 'Priority is required!';
  ATLEAST_REQUIRED = 'Please select Technician/Engineer!!';

  START_DATE_REQUIRED = 'Start Date is required!';
  END_DATE_REQUIRED = 'End Date is required!';

  SERIAL_NO_REQUIRED = 'Serial No is required!';
  PRE_FIX_REQUIRED = 'Pre Fix is required!';
  MACHINE_NO_REQUIRED = 'Machine No is required!';

  ROLE_REQUIRED = 'Role is required!';

  CODE_REQUIRED = 'Code is required!';

  NOTE_REQUIRED = 'Note is required!';

  CUSTOMER_NAME_REQUIRED = 'Customer Name is required!';
  MOBILE_NUMBER_REQUIRED = 'Mobile Number is required!';
  MOBILE_NUMBER_INVALID = 'Please enter valid Mobile Number!';
  ALTERNATIVE_MOBILE_NUMBER_REQUIRED = 'Alternative Mobile Number is required!';
  ALTERNATIVE_MOBILE_NUMBER_INVALID =
    'Please enter valid Alternative Mobile Number!';

  USER_REQUIRED = 'User is required!';
  FORM_NUMBER_REQUIRED = 'Form Number is required!';
  BOOKING_NUMBER_REQUIRED = 'Booking Number is required!';
  ADDRESS_REQUIRED = 'Address is required!';
  BOOKING_DATE_REQUIRED = 'Booking Date is required!';
  BOOKING_DATE_INVALID = 'Please enter valid Booking Date!';
  FROM_MONTH_REQUIRED = 'From Month is required!';
  TO_MONTH_REQUIRED = 'To Month is required!';
  DELIVERY_DATE_REQUIRED = 'Delivery Date is required!';
  FOLLOW_UP_REMINDERS_DATE_REQUIRED = 'Follow-Up Reminders Date is required!';
  REFERENCE_MOBILE_NUMBER_INVALID =
    'Please enter valid Reference Mobile Number!';
  ADVANCE_PAYMENT_INVALID = 'Please enter valid Advance Payment Amount!';
  ADVANCE_RECEIVED_INVALID = 'Please enter valid Advance Received Amount!';
  TOTAL_ADVANCE_PAYMENT_INVALID = 'Please enter valid Total Advance Payment Amount!';
  TOTAL_ADVANCE_PAYMENT_REQUIRED = 'Total Advance Payment is required!';

  NEEDLE_REQUIRED = 'Required!';
  HEAD_REQUIRED = 'Required!';
  HEAD_DISTANCE_REQUIRED = 'Required!';
  PENTA_REQUIRED = 'Required!';
  Y_CODE_REQUIRED = 'Required!';
  THREAD_LOCK_REQUIRED = 'Required!';
  LHS_REQUIRED = 'Required!';
  LHS_DESCRIPTION_REQUIRED = 'Required!';
  RHS_REQUIRED = 'Required!';
  RHS_DESCRIPTION_REQUIRED = 'Required!';
  QTY_REQUIRED = 'Required!';
  AMOUNT_REQUIRED = 'Required!';
 ORDER_NO_REQUIRED = 'Required!';
  NON_PAYMENT_NOTIFICATION_REQUIRED =
    'Non Payment Notification Days is required!';
  NON_PAYMENT_NOTIFICATION_INVALID = 'Invalid notification!';
  PRE_DELIVERY_DAYS_REQUIRED = 'Pre-delivery days are required!';
  PRE_DELIVERY_DAYS_INVALID = 'Invalid pre-delivery days!';
  WHATSAPP_MSG_REQUIRED = 'WhatsApp message is required!';
  TERMS_CONDITIONS_REQUIRED = 'Terms and conditions are required!';
  TERMS_CONDITIONS_ENGLISH_REQUIRED = 'Terms and conditions (English) are required!';

  FIRM_NAME_REQUIRED = 'Firm Name is required!';
  RECEIVED_AMOUNT_INVALID = 'Please enter valid Received Amount!';
  RECEIVED_AMOUNT_REQUIRED = 'Received Amount is required!';
  COMPUTER_REQUIRED = 'Computer is required!';
  FORM_NO_REQUIRED = 'Form No is required!';
  ORDER_NUMBER_REQUIRED = 'Order Number is required!';
  PAYMENT_DATE_REQUIRED = 'Payment Date is required!';
  SALES_PERSON_REQUIRED = 'Sales Person is required!';
  DUTY_SCHEMES_REQUIRED = 'Duty Schemes is required!';
  FOLLOW_UP_REMINDERS_NOTES_REQUIRED = 'Follow-Up Reminder Note is required!';
  PAYMENT_DATE_INVALID = 'Please enter valid Payment Date!';
  ORDER_UPDATE_NOTES_REQUIRED = 'Order Update Note is required!';

  MACHINE_STATUS_REQUIRED = 'Machine Status is required!';
}
